"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecondaryButton = exports.PrimaryButton = exports.Button = void 0;
const react_1 = __importDefault(require("react"));
const rn_css_1 = __importStar(require("rn-css"));
const base_ui_text_text_1 = require("@unboared/base-ui.text.text");
const base_ui_elements_icon_1 = require("@unboared/base-ui.elements.icon");
const base_ui_responsive_sizes_1 = require("@unboared/base-ui.responsive.sizes");
const base_ui_theme_themes_1 = require("@unboared/base-ui.theme.themes");
const button_preset_1 = require("./button.preset");
const base_ui_theme_spacing_1 = require("@unboared/base-ui.theme.spacing");
/**
 * For your text displaying needs.
 *
 * This component is a HOC over the built-in React Native one.
 */
const Button = (_a) => {
    var { size = 20 } = _a, props = __rest(_a, ["size"]);
    // grab the props
    const { tx, text, icon, style: styleOverride, textStyle: textStyleOverride, children, preset, disabled, focus, active } = props, rest = __rest(props, ["tx", "text", "icon", "style", "textStyle", "children", "preset", "disabled", "focus", "active"]);
    const theme = (0, rn_css_1.useTheme)();
    const currentTheme = theme || base_ui_theme_themes_1.defaultTheme;
    const { normalize } = (0, base_ui_responsive_sizes_1.useNormalize)();
    const viewTheme = (0, button_preset_1.viewPresets)(currentTheme, active);
    const viewStyle = viewTheme[preset || 'primary'];
    const viewStyles = [viewStyle, styleOverride];
    const textTheme = (0, button_preset_1.textPresets)(currentTheme);
    const textStyle = textTheme[preset || 'primary'];
    const textStyles = [{ fontSize: normalize(0.5 * size) }, textStyle, textStyleOverride];
    const iconOnly = (tx === undefined && text === undefined);
    const content = children
        || react_1.default.createElement(ButtonContent, { marginHorizontal: iconOnly ? 0 : normalize(base_ui_theme_spacing_1.space.tiny), size: normalize(size) },
            icon && react_1.default.createElement(base_ui_elements_icon_1.Icon, { name: icon, color: ((textStyleOverride && textStyleOverride.color) || textStyle.color), size: size }),
            react_1.default.createElement(TextContent, { tx: tx, text: text, style: textStyles, margin: iconOnly ? 0 : normalize(base_ui_theme_spacing_1.space.tiny) }));
    return (react_1.default.createElement(ButtonContainer, Object.assign({ normalize: normalize, focus: focus, disabled: disabled, active: active, style: viewStyles }, rest), content));
};
exports.Button = Button;
const ButtonContainer = rn_css_1.default.TouchableOpacity `
  opacity: ${props => (props.disabled ? 0.5 : 'unset')};

  border-radius: ${props => props.normalize(base_ui_theme_spacing_1.size.borderRadius.smaller)};
  -moz-border-radius: ${props => props.normalize(base_ui_theme_spacing_1.size.borderRadius.smaller)};
  -webkit-border-radius: ${props => props.normalize(base_ui_theme_spacing_1.size.borderRadius.smaller)}; 

  padding-vertical: ${props => props.normalize(base_ui_theme_spacing_1.space.tiny)};
  padding-horizontal: ${props => props.normalize(base_ui_theme_spacing_1.space.tiny)};

  border: ${props => (props.focus ? `${props.normalize(base_ui_theme_spacing_1.size.borderWidth.small)} solid #cdccd1` : 'unset')};
`;
const ButtonContent = rn_css_1.default.View `
  flex-direction : row;
  align-items: center;
  justify-content: center;
  height : ${props => props.size};
  marginHorizontal: ${props => props.marginHorizontal};
`;
const TextContent = (0, rn_css_1.default)(base_ui_text_text_1.Text) `
  margin-left : ${props => props.margin};
`;
const PrimaryButton = (props) => react_1.default.createElement(exports.Button, Object.assign({ preset: 'primary' }, props));
exports.PrimaryButton = PrimaryButton;
const SecondaryButton = (props) => react_1.default.createElement(exports.Button, Object.assign({ preset: 'secondary' }, props));
exports.SecondaryButton = SecondaryButton;
//# sourceMappingURL=button.js.map